var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesOps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31315_99971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3V2H13.5V1H12.5V2H12C11.4485 2 11 2.449 11 3V4C11 4.5515 11.4485 5 12 5H14V6H11V7H12.5V8H13.5V7H14C14.5515 7 15 6.5515 15 6V5C15 4.449 14.5515 4 14 4H12V3H15ZM12 10V11H13.293L11.5 12.793L10.354 11.6465C10.2604 11.5528 10.1334 11.5002 10.001 11.5H10C9.86758 11.5002 9.74062 11.5528 9.647 11.6465L7 14.293L7.707 15L10.0005 12.707L11.1465 13.8535C11.2403 13.9472 11.3674 13.9999 11.5 13.9999C11.6326 13.9999 11.7597 13.9472 11.8535 13.8535L14 11.707V13H15V10H12ZM2 15H1V12.5C1 10.57 2.57 9 4.5 9H7.5C8.4945 9 9.445 9.425 10.1085 10.1665L9.3635 10.8335C9.12901 10.5713 8.84182 10.3615 8.5207 10.2179C8.19959 10.0742 7.85177 10 7.5 10H4.5C3.1215 10 2 11.1215 2 12.5V15ZM6 8C6.92826 8 7.8185 7.63125 8.47487 6.97487C9.13125 6.3185 9.5 5.42826 9.5 4.5C9.5 3.57174 9.13125 2.6815 8.47487 2.02513C7.8185 1.36875 6.92826 1 6 1C5.07174 1 4.1815 1.36875 3.52513 2.02513C2.86875 2.6815 2.5 3.57174 2.5 4.5C2.5 5.42826 2.86875 6.3185 3.52513 6.97487C4.1815 7.63125 5.07174 8 6 8ZM6 2C6.66304 2 7.29893 2.26339 7.76777 2.73223C8.23661 3.20107 8.5 3.83696 8.5 4.5C8.5 5.16304 8.23661 5.79893 7.76777 6.26777C7.29893 6.73661 6.66304 7 6 7C5.33696 7 4.70107 6.73661 4.23223 6.26777C3.76339 5.79893 3.5 5.16304 3.5 4.5C3.5 3.83696 3.76339 3.20107 4.23223 2.73223C4.70107 2.26339 5.33696 2 6 2Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31315_99971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesOps);
export default __webpack_public_path__ + "static/media/sales-ops.9b7fc86cfc0c832dbbc1eec922978d1c.svg";
export { ForwardRef as ReactComponent };